<customizer-component-header [menu]="menu" (updateCollapsedOnComponent)="updateCollapsed($event)">

	@if (loading) {
	<div class="parts-list spinner-wrapper">
		<img class="spinner" [src]="'/assets/animations/Framespinner.gif'" />
		<div class="smaller">{{ 'CUSTOMISER.MENUS.PARTS.LOADING' | translate }}</div>
	</div>
	}

	@if (!loading) {
	<div class="parts-list">
		@if (partsAndPrices && partsAndPrices.length > 0) {
		@for (part of partsAndPrices; track part) {
		<div>
			<checkbox ngClass="checkbox-menu" [isPrecious]="isPrecious"
				[id]="part.name" [label]="'PARTS.' + part.name | translate"
				[icon]="imageService.getPartsIcon(part.name)"
				[checked]="selectedParts.includes(part.name)"
				(click)="togglePart(part.name)" />
			@if (showPrices) {
			@if (!pricesLoaded) {
			<div class="pv">{{ 'CUSTOMISER.MENUS.PARTS.LOADING_PRICES' | translate }}</div>
			}
			@if (pricesLoaded) {
			<app-price-viewer class="pv" [priceItem]="part.priceItem"></app-price-viewer>
			}
			}
		</div>
		}
		<div class="info">{{ 'CUSTOMISER.MENUS.PARTS.HEADS_UP' | translate }}</div>
		}
		@if (!partsAndPrices || partsAndPrices.length === 0) {
		<div class="smaller">{{ 'CUSTOMISER.MENUS.PARTS.NO_PARTS' | translate }}</div>
		}
	</div>
	}

</customizer-component-header>